export default {
  summary: '/resumen',
  orders: '/ordenes',
  cotizaciones: '/cotizaciones',
  catalog: '/catalogo',
  messages: '/mensajes',
  customers: '/clientes',
  reports: '/reportes',
  login: '/ingreso',
  loginCode: '/ingreso-codigo',
  logout: '/salir',
  category: '/categorias',
  users: '/usuarios',
  detail: '/detalle',
  profile: '/perfil',
  recoverPassword: '/contrasena',
  resetPassword: '/resetPassword',
  registration: '/registro',
};
